export interface BFStorage {
  getItem(key: string): Promise<unknown>;
  removeItem(key: string): Promise<void>;
  setItem(key: string, item: string): Promise<void>;
}
export const STORAGE_TOKEN = 'STORAGE';
